import { format } from 'date-fns';
import { arSA } from 'date-fns/locale';

export const logoPath = '/img/logo.png';

export const AMPPrefix = 'amp/';
export const isAmpPage = (url: string) => url.toLowerCase().includes(AMPPrefix);

export const commonDateLongFormat = 'EEEE, dd MMMM yyyy';

export const retrieveTitle = (date: Date, intl: any, sign: string = null) => {
  let segments = [intl.formatMessage({ id: 'site.title' })];

  if (!sign) {
    segments.push(
      intl.formatMessage(
        {
          id: 'site.title.description',
        },
        {
          date: format(date, commonDateLongFormat, { locale: intl.locale == 'ar' ? arSA : null }),
        }
      )
    );
  } else {
    segments.push(
      intl.formatMessage(
        {
          id: 'site.title.sign.description',
        },
        {
          sign: intl.formatMessage({ id: `signs.${sign.toLowerCase()}` }),
          date: format(date, commonDateLongFormat, { locale: intl.locale == 'ar' ? arSA : null }),
        }
      )
    );
  }

  return segments.join(' | ');
};

export const retrieveDescription = (date: Date, intl: any, sign: string = null) => {
  let segments = [];

  if (!sign) {
    segments.push(
      intl.formatMessage(
        {
          id: 'site.description',
        },
        {
          date: format(date, commonDateLongFormat, { locale: intl.locale == 'ar' ? arSA : null }),
        }
      )
    );
  } else {
    segments.push(
      intl.formatMessage(
        {
          id: 'site.sign.description',
        },
        {
          sign: intl.formatMessage({ id: `signs.${sign.toLowerCase()}` }),
          date: format(date, commonDateLongFormat, { locale: intl.locale == 'ar' ? arSA : null }),
        }
      )
    );
  }

  return segments.join('. ');
};

export const select = (langKey: string) => {
  var res;
  switch (langKey) {
    case 'en':
      res = 0;
      break;
    case 'ar':
      res = 1;
      break;
    default:
      res = null;
  }
  return res;
};

type dateObj = { year: number; month: number; day: number };
export const formatDateUrl = (date: Date | dateObj) => {
  let year, month, day;
  let finalDate: Date;
  if (date instanceof Date) {
    finalDate = date;
  } else {
    ({ year, month, day } = <dateObj>date);
    finalDate = new Date(year, month - 1, day, 0, 0, 0, 0);
  }

  return format(finalDate, 'yyyy/MM/dd');
};
